import { ReturnOpportunityProductReadable } from '@crm/api'

export const getLineTotal = (
  product: ReturnOpportunityProductReadable
): number => {
  const price = Number(product.custom_price) || 0
  const qty = Number(product.quantity) || 0
  const discount = Number(product.extra_discount) || 0

  return price * qty * (1 - discount / 100)
}
